import { api } from '../config/api';

export const interactionService = {
  // Obtener interacciones de un contacto
  getByContactId: async (contactId, params = {}) => {
    const queryParams = new URLSearchParams();
    queryParams.append('contact_id', contactId);
    if (params.skip) queryParams.append('skip', params.skip);
    if (params.limit) queryParams.append('limit', params.limit);
    
    const queryString = queryParams.toString();
    return await api.get(`/interactions/?${queryString}`);
  },

  // Obtener una interacción por ID
  getById: async (id) => {
    return await api.get(`/interactions/${id}/`);
  },

  // Crear una interacción
  create: async (interactionData) => {
    // Convertir fecha a formato ISO si es necesario
    const data = {
      ...interactionData,
      date: interactionData.date instanceof Date 
        ? interactionData.date.toISOString() 
        : interactionData.date,
    };
    return await api.post('/interactions/', data);
  },

  // Actualizar una interacción
  update: async (id, interactionData) => {
    const data = {
      ...interactionData,
      date: interactionData.date instanceof Date 
        ? interactionData.date.toISOString() 
        : interactionData.date,
    };
    return await api.put(`/interactions/${id}/`, data);
  },

  // Eliminar una interacción
  delete: async (id) => {
    return await api.delete(`/interactions/${id}/`);
  },
};

